export default "__VITE_ASSET__uiGZz24C__"